import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { RunOnceScheduler } from 'vscode/vscode/vs/base/common/async';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import { IDebugService } from 'vscode/vscode/vs/workbench/contrib/debug/common/debug.service';
import { CellUri } from 'vscode/vscode/vs/workbench/contrib/notebook/common/notebookCommon';
import { CellExecutionUpdateType } from 'vscode/vscode/vs/workbench/contrib/notebook/common/notebookExecutionService';
import { INotebookExecutionStateService } from 'vscode/vscode/vs/workbench/contrib/notebook/common/notebookExecutionStateService.service';

let NotebookCellPausing = class NotebookCellPausing extends Disposable {
    constructor(_debugService, _notebookExecutionStateService) {
        super();
        this._debugService = _debugService;
        this._notebookExecutionStateService = _notebookExecutionStateService;
        this._pausedCells = ( new Set());
        this._register(_debugService.getModel().onDidChangeCallStack(() => {
            this.onDidChangeCallStack(true);
            this._scheduler.schedule();
        }));
        this._scheduler = this._register(( new RunOnceScheduler(() => this.onDidChangeCallStack(false), 2000)));
    }
    async onDidChangeCallStack(fallBackOnStaleCallstack) {
        const newPausedCells = ( new Set());
        for (const session of this._debugService.getModel().getSessions()) {
            for (const thread of session.getAllThreads()) {
                let callStack = thread.getCallStack();
                if (fallBackOnStaleCallstack && !callStack.length) {
                    callStack = thread.getStaleCallStack();
                }
                callStack.forEach(sf => {
                    const parsed = CellUri.parse(sf.source.uri);
                    if (parsed) {
                        newPausedCells.add(( sf.source.uri.toString()));
                        this.editIsPaused(sf.source.uri, true);
                    }
                });
            }
        }
        for (const uri of this._pausedCells) {
            if (!( newPausedCells.has(uri))) {
                this.editIsPaused(( URI.parse(uri)), false);
                this._pausedCells.delete(uri);
            }
        }
        newPausedCells.forEach(cell => this._pausedCells.add(cell));
    }
    editIsPaused(cellUri, isPaused) {
        const parsed = CellUri.parse(cellUri);
        if (parsed) {
            const exeState = this._notebookExecutionStateService.getCellExecution(cellUri);
            if (exeState && (exeState.isPaused !== isPaused || !exeState.didPause)) {
                exeState.update([{
                        editType: CellExecutionUpdateType.ExecutionState,
                        didPause: true,
                        isPaused
                    }]);
            }
        }
    }
};
NotebookCellPausing = ( __decorate([
    ( __param(0, IDebugService)),
    ( __param(1, INotebookExecutionStateService))
], NotebookCellPausing));
( Registry.as(Extensions.Workbench)).registerWorkbenchContribution(NotebookCellPausing, 3 );
